var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box", style: { width: _vm.width + "px" } }, [
    _vm.isTitleView == "extra"
      ? _c("div", { staticClass: "top" }, [
          _c("div", { staticClass: "top-wrap" }, [
            _c(
              "div",
              {
                staticClass: "top-title",
                style: {
                  width: _vm.showExtra
                    ? `calc(100% - ${_vm.extraWidth}px)`
                    : "100%",
                },
              },
              [
                _vm.prefixImg
                  ? _c("img", { attrs: { src: _vm.imgIcon, alt: "" } })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "title",
                    style: {
                      width: _vm.prefixImg ? `calc(100% - 32px)` : "100%",
                    },
                  },
                  [_vm._t("title")],
                  2
                ),
              ]
            ),
            _vm.showExtra
              ? _c(
                  "div",
                  {
                    staticClass: "extra",
                    style: { width: _vm.extraWidth + "px" },
                  },
                  [_vm._t("extra")],
                  2
                )
              : _vm._e(),
          ]),
        ])
      : _c("div", { staticClass: "top-b" }, [
          _c("div", { staticClass: "top-wrap" }, [
            _c(
              "div",
              {
                staticClass: "top-title",
                style: {
                  width: _vm.showExtra
                    ? `calc(100% - ${_vm.extraWidth}px)`
                    : "100%",
                },
              },
              [
                _vm.prefixImg
                  ? _c("img", { attrs: { src: _vm.imgIcon, alt: "" } })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "title",
                    style: {
                      width: _vm.prefixImg ? `calc(100% - 32px)` : "100%",
                    },
                  },
                  [_vm._t("title")],
                  2
                ),
              ]
            ),
            _vm.showExtra
              ? _c(
                  "div",
                  {
                    staticClass: "extra",
                    style: { width: _vm.extraWidth + "px" },
                  },
                  [_vm._t("extra")],
                  2
                )
              : _vm._e(),
          ]),
        ]),
    _c("div", { staticClass: "main" }, [_vm._t("main")], 2),
    _c("div", { staticClass: "pager" }, [_vm._t("pager")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }